import request from '@/utils/request'


// 查询任务提交-订单关联列表
export function listTaskSubmitOrder(query) {
  return request({
    url: '/task/task/submit/order/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询任务提交-订单关联分页
export function pageTaskSubmitOrder(query) {
  return request({
    url: '/task/task/submit/order/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询任务提交-订单关联详细
export function getTaskSubmitOrder(data) {
  return request({
    url: '/task/task/submit/order/detail',
    method: 'get',
    params: data
  })
}

// 新增任务提交-订单关联
export function addTaskSubmitOrder(data) {
  return request({
    url: '/task/task/submit/order/add',
    method: 'post',
    data: data
  })
}

// 修改任务提交-订单关联
export function updateTaskSubmitOrder(data) {
  return request({
    url: '/task/task/submit/order/edit',
    method: 'post',
    data: data
  })
}

// 删除任务提交-订单关联
export function delTaskSubmitOrder(data) {
  return request({
    url: '/task/task/submit/order/delete',
    method: 'post',
    data: data
  })
}
